import { idmsApi } from "../api"
import { API_LOGIN, API_VALIDATE_TOKEN } from "../ApiConstants"

type ValidateTokenResponse = {
  isValid?: boolean
  IsValid?: boolean
}

const accountsApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (request) => ({
        url: API_LOGIN,
        method: "POST",
        body: request,
      }),
    }),
    validateToken: builder.query<ValidateTokenResponse, string>({
      query: (token) => ({
        url: API_VALIDATE_TOKEN,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
})

export const { useLoginMutation, useLazyValidateTokenQuery } = accountsApi
